import { IAuctionPurchases } from './IPurchasedAuction';
import { MyPurchasesCellViewModel } from './MyPurchasesCellViewModel';
export class MyPurchasesViewModel {
  cellViewModels: MyPurchasesCellViewModel[];
  constructor(data: IAuctionPurchases[]) {
    this.cellViewModels = data.map(d => new MyPurchasesCellViewModel(d));
  }
}
